import React from 'react';

interface BinIconProps extends React.SVGProps<SVGSVGElement> {
    width?: number | string;
    height?: number | string;
    fill?: string;
}

export const BinIcon: React.FC<BinIconProps> = ({
    width = 17,
    height = 19,
    fill = '#E30613',
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.29199 18.875C2.71908 18.875 2.22845 18.6708 1.82012 18.2625C1.41178 17.8542 1.20796 17.3639 1.20866 16.7917V3.25H0.166992V1.16667H5.37533V0.125H11.6253V1.16667H16.8337V3.25H15.792V16.7917C15.792 17.3646 15.5878 17.8552 15.1795 18.2635C14.7712 18.6719 14.2809 18.8757 13.7087 18.875H3.29199ZM5.37533 14.7083H7.45866V5.33333H5.37533V14.7083ZM9.54199 14.7083H11.6253V5.33333H9.54199V14.7083Z"
            fill={fill}
        />
    </svg>
);
